"use client";
import { Popover as o, PopoverContext as d } from "@ark-ui/react";
import { popover as g } from "@huspy/styled-system/recipes";
import { createStyleContext as m } from "../../utils/createStyleContext.mjs";
const { withRootProvider: v, withContext: r } = m(g), T = v(o.Root), e = r(
  o.Anchor,
  "anchor"
), t = r(
  o.Arrow,
  "arrow"
), i = r(
  o.ArrowTip,
  "arrowTip"
), n = r(o.CloseTrigger, "closeTrigger"), p = r(
  o.Content,
  "content"
), s = r(o.Description, "description"), a = r(
  o.Indicator,
  "indicator"
), c = r(
  o.Positioner,
  "positioner"
), l = r(
  o.Title,
  "title"
), P = r(
  o.Trigger,
  "trigger"
), N = {
  Context: d,
  Root: T,
  Anchor: e,
  Arrow: t,
  ArrowTip: i,
  CloseTrigger: n,
  Content: p,
  Description: s,
  Indicator: a,
  Positioner: c,
  Title: l,
  Trigger: P
};
e.displayName = "PopoverAnchor";
t.displayName = "PopoverArrow";
i.displayName = "PopoverArrowTip";
n.displayName = "PopoverCloseTrigger";
p.displayName = "PopoverContent";
s.displayName = "PopoverDescription";
a.displayName = "PopoverIndicator";
c.displayName = "PopoverPositioner";
l.displayName = "PopoverTitle";
P.displayName = "PopoverTrigger";
export {
  N as Popover
};
